// utils/skillVerification.js
export const skillCategories = [
    'Food & Safety',
    'Transportation', 
    'Organization',
    'Facilities',
    'Technology',
    'Education',
    'Healthcare',
    'Construction',
    'Other'
  ];
  
  export const tierDescriptions = {
    1: {
      name: 'Self-Reported',
      description: 'Basic skills that can be self-verified',
      color: 'green',
      trustRequired: 3.0
    },
    2: {
      name: 'Document Verified',
      description: 'Skills requiring certification or license',
      color: 'yellow',
      trustRequired: 3.5
    },
    3: {
      name: 'Professional',
      description: 'High-level professional certifications',
      color: 'purple',
      trustRequired: 4.0
    }
  };
  
  export const validateSkillDocument = (file) => {
    const validTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxSize = 5 * 1024 * 1024; // 5MB
    
    if (!validTypes.includes(file.type)) {
      return { valid: false, error: 'Invalid file type. Please upload JPEG, PNG, or PDF.' };
    }
    
    if (file.size > maxSize) {
      return { valid: false, error: 'File too large. Maximum size is 5MB.' };
    }
    
    return { valid: true };
  };
  
  export const getSkillRequirements = (skillId, skills) => {
    const skill = skills.find(s => s.id === skillId);
    if (!skill) return null;
    
    return {
      ...skill,
      canVerify: (userTrustScore) => userTrustScore >= skill.trustRequirement,
      estimatedReviewTime: skill.tier === 1 ? 'Instant' : skill.tier === 2 ? '1-2 days' : '2-3 days'
    };
  };
  
  export const formatSkillStatus = (status) => {
    const statusMap = {
      verified: { label: 'Verified', color: 'green' },
      pending: { label: 'Under Review', color: 'yellow' },
      rejected: { label: 'Rejected', color: 'red' },
      expired: { label: 'Expired', color: 'gray' },
      unverified: { label: 'Not Verified', color: 'gray' }
    };
    
    return statusMap[status] || statusMap.unverified;
  };